import React from "react";
import "../../assets/css/advertising.css";
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
import { Button, Stack, AlertTitle, Chip } from "@mui/material";
import { useHistory } from "react-router-dom";
import { useDispatch } from "react-redux";
import config from "../../api/config";
import { setToast } from "../../redux/actions/ToastAction";
import Alert from "../alert";

const CURL = () => {
  const { location } = useHistory();
  const data = location.data;
  const navigate = useHistory();
  const dispatch = useDispatch();
  // tabs

  const Confirm = async () => {
    try {
      const res = await config.post(
        `/api/moderator/v1/searchWebUrl/${data?.id}`
      );
      // dispatch(setToast("true", "success", "Успешно опубликовано"));
      dispatch(setToast(true, "info", res.data?.message));
      navigate.push("/");
    } catch (err) {
      console.error(err?.message);
    }
  };
  return (
    <div className="advertising">
      <div className="d-flex align-items-center justify-content-between">
        <Button
          onClick={() => navigate.push(`/confirm`)}
          variant="outlined"
          startIcon={<ArrowBackIosNewIcon />}
          style={{
            padding: "12px 22px",
            borderRadius: "40px",
            fontWeight: "bold",
          }}
        >
          Отменить и назад
        </Button>
        <Stack direction="row" spacing={2}>
          <Button
            variant="outlined"
            style={{
              padding: "8px 18px",
              borderRadius: "40px",
            }}
            onClick={() =>
              navigate.push({
                pathname: `/url_ad`,
                data: data,
              })
            }
          >
            Изменить
          </Button>
          <Button
            variant="contained"
            style={{
              background: "var(--main-color)",
              fontWeight: "bold",
              padding: "12px 22px",
              borderRadius: "40px",
            }}
            onClick={Confirm}
          >
            {data?.isSent ? "Опубликовать снова" : "Подтвердить"}
          </Button>
        </Stack>
      </div>{" "}
      <br />
      <p style={{ color: "var(--second-color)" }}>Название: </p>
      <h2>{data?.name}</h2> <br />
      <p style={{ color: "var(--second-color)" }}>URL: </p>
      <h4>
        <a href={data?.url} target="_blank" rel="noopener noreferrer">
          Открыть ссылку в новой вкладке
        </a>
      </h4>{" "}
      {data?.iconUrl && (
        <>
          <p style={{ color: "var(--second-color)" }}>Значок рекламы: </p>
          <div className="w-25 my-5">
            <img
              src={data.iconUrl}
              alt=""
              className="img-fluid"
            />
          </div>
        </>
      )}
      <br />
      <p style={{ color: "var(--second-color)" }}>Статус: </p>
      <Alert severity={data?.isSent ? "success" : "error"} className="my-3">
        <AlertTitle>
          {data?.isSent ? "Подтверждено" : "Не подтверждено"}
        </AlertTitle>
      </Alert>{" "}
      <br />
      <Stack direction="row" spacing={1}>
        {data?.keywords.map((v, i) => (
          <Chip label={v.key} variant="outlined" />
        ))}
      </Stack>
    </div>
  );
};

export default CURL;
